import { POSITION_PER_MARK, getValueLabelValue } from "../../utils/timeSlider";
import { useEffect, useState } from "react";

import { isWaveEditModeSelector } from "../../reducers/matrixProfile/selectors";
import { makeStyles } from "@mui/styles";
import { memo } from "react";
import { useSelector } from "react-redux";

const useStyles = makeStyles({
  root: {
    backgroundColor: "white",
    borderRadius: "50%",
    zIndex: 101,
    height: 12,
    width: 12,
    position: "absolute",
    marginTop: "-3px",
    marginLeft: "-6px",
    border: "1px black solid",
    pointerEvents: (props) => (props.isWaveEditMode ? "auto" : "none"),
  },
});

export const SlidingDot = memo(
  ({ wave, bbox, duration, max = 100, min = 0, onDragEnd }) => {
    const [dragImage, setDragImage] = useState();
    const [newLeft, setNewLeft] = useState();
    const isWaveEditMode = useSelector(isWaveEditModeSelector);

    const styles = useStyles({ isWaveEditMode });

    useEffect(() => {
      const image = new Image(0, 0);
      image.src =
        "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
      setDragImage(image);
    }, []);

    return (
      <div
        className={styles.root}
        style={{
          left: `${
            !isNaN(newLeft) && newLeft !== null ? newLeft : wave.position
          }%`,
        }}
        onDragEnd={() => {
          const difference = wave.position - newLeft;
          onDragEnd &&
            onDragEnd({
              ...wave,
              newWaveTime: getValueLabelValue(
                wave.time - (difference / POSITION_PER_MARK[duration]) * 25
              ),
            });
          setNewLeft();
        }}
        onDrag={(e) => {
          const leftFromEvent =
            Math.round(
              (((e.clientX - bbox?.left) / bbox?.width) * 100) /
                POSITION_PER_MARK[duration]
            ) * POSITION_PER_MARK[duration];
          if (leftFromEvent > max || leftFromEvent < min) return;
          setNewLeft(leftFromEvent);
        }}
        onDragStart={(e) => e.dataTransfer.setDragImage(dragImage, 0, 0)}
        draggable={true}
      />
    );
  }
);
